import styled from 'styled-components';

export const TimelineWrapper = styled.div`
    position: relative;
    width: 100%;
    height: 6rem;
    overflow: hidden;
    background-color: #1c1c1c;
    border-radius: 8px;
    margin-top: 10px;
`;

export const TimelineContainer = styled.div<{$offsetX: number}>`
    position: absolute;
    top: 0;
    left: 10%; // 기준선 위치
    height: 100%;
    width: 2000px; // 10시간 × 200px
    transform: translateX(${({$offsetX}) => -$offsetX}px); // 흐름 구현
    transition: transform 0.5s linear;
`;

export const EventBlock = styled.div<{$isLive: boolean; $left: number; $width: number; $color: string}>`
    position: absolute;
    top: 10px;
    height: calc(100% - 30px);
    background-color: ${({$isLive, $color}) => ($isLive ? $color : '#374151')};
    color: white;
    border-radius: 6px;
    padding: 8px;
    width: ${({$width}) => $width}px;
    left: ${({$left}) => $left}px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    box-sizing: border-box;
    overflow: hidden;

    .time {
        font-size: 15px;
        color: #ccc;
    }

    .title {
        font-size: 20px;
        text-align: center;
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
    }
`;

export const CurrentTimeIndicator = styled.div`
    position: absolute;
    top: 0;
    bottom: 0;
    width: 2px;
    background-color: red;
    z-index: 10;
    left: 10%;
`;
